var _defs, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSwastic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 26 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#a7a9ac;fill-rule:evenodd;stroke:#808285;stroke-miterlimit:2.6;stroke-width:.2px;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m.1.1s1.7.7,1.4,7.5c-.3,6.8,1,6.9,3.8,7,2.8,0,5.7.2,5.7.2v6.5c.1.2-9.6-1.6-10.9,4.6,0,0,.8-2.1,6.9-1.9,6.6.3,3.7.1,3.7.1,0,0,3.5.6,3.8-2.9l.2-6.4h6.6v5.1s.2,4.7,4.7,6.1c0,0-2.5-.9-1.9-7.4v-3.4c-.1,0,.9-4.1-3.6-3.9h-5.9s.1-6.5.1-6.5h4.1c0-.1,5.4.1,7.2-4.6,0,0-2.1,1.8-8.5,1.7h-3s-3.5-.3-3.1,3.3l-.2,6.2h-6.6s-.1-4.6-.1-4.6C4.3,6.6,5.1,2.4.1.1H.1Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m7.5,5.7c1,0,1.8.8,1.8,1.8s-.8,1.8-1.8,1.8-1.8-.8-1.8-1.8.8-1.8,1.8-1.8h0Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m18.2,5.7c1,0,1.8.8,1.8,1.8s-.8,1.8-1.8,1.8-1.8-.8-1.8-1.8.8-1.8,1.8-1.8h0Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m17.9,15.8c1,0,1.8.8,1.8,1.8s-.8,1.8-1.8,1.8-1.8-.8-1.8-1.8.8-1.8,1.8-1.8h0Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m7.2,15.8c1,0,1.8.8,1.8,1.8s-.8,1.8-1.8,1.8-1.8-.8-1.8-1.8.8-1.8,1.8-1.8h0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwastic);
export default __webpack_public_path__ + "static/media/swastic.9c966f43cd8f78841906fd9d5ceccc45.svg";
export { ForwardRef as ReactComponent };